module.exports = __webpack_public_path__ + "st-vincent-and-the-grenadines.svg?cfe9e916c0bfb7f85d0e92cb230c531a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/st-vincent-and-the-grenadines.svg
// module id = 306
// module chunks = 10